module.exports = __webpack_public_path__ + "img/horse-racing.6c6242c3.svg";